import { Typography } from "@mui/material";
import styles from "../index.module.css";
import { baseTransKey, ErrorWelcomePageKey, getErrorPageMessage } from "../takeAssessmentHelper";
import i18n from "../../../../i18n";
import PurpleWarningIcon from "../../../../images/portal/purple-warning.svg?react";
import { CoreProctoringTimer, CoreSkeletonWrapper } from "@verity/components/core";
import { QuizTimerStatus } from "../hooks/useQuizTimer";

export function WarningContainer({ children }: { children: React.ReactNode }) {
	return (
		<div className={styles.welcomeErrorBox}>
			<PurpleWarningIcon />
			<Typography>{children}</Typography>
		</div>
	);
}

type TakeAssessmentErrorBoxProps = {
	type: ErrorWelcomePageKey | "afterEnd";
} & Pick<QuizTimerStatus, "windowStatus">;

export default function TakeAssessmentErrorBox({ type, windowStatus }: TakeAssessmentErrorBoxProps) {
	const { timeBeforeStart } = windowStatus;

	return (
		<div className={styles.welcomeErrorBoxContainer}>
			{type === "beforeStart" && (
				<CoreSkeletonWrapper loading={timeBeforeStart === undefined}>
					<CoreProctoringTimer timeMs={timeBeforeStart ?? 0} label={i18n.t(`${baseTransKey}.error.sessionStarts`)} />
				</CoreSkeletonWrapper>
			)}
			<WarningContainer>{getErrorPageMessage(type)}</WarningContainer>
		</div>
	);
}
